"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RawEmailEditor = void 0;

var _preact = require("preact");

var _CodeEditor = _interopRequireDefault(require("@insided/shared/uikit/CodeEditor"));

var RawEmailEditor = function RawEmailEditor(_ref) {
  var content = _ref.content,
      onContentChange = _ref.onContentChange,
      contentForPreview = _ref.contentForPreview,
      onBlur = _ref.onBlur,
      setCodeMirrorRef = _ref.setCodeMirrorRef;
  return (0, _preact.h)("div", {
    className: "raw-email-editor"
  }, (0, _preact.h)("div", {
    className: "raw-email-editor-wrapper"
  }, (0, _preact.h)("div", {
    className: "raw-email-editor__preview-wrapper"
  }, (0, _preact.h)("label", null, "Email preview"), (0, _preact.h)("div", {
    className: "raw-email-editor__preview",
    dangerouslySetInnerHTML: {
      __html: contentForPreview || content
    }
  })), (0, _preact.h)("div", null, (0, _preact.h)("label", null, "Custom HTML"), (0, _preact.h)(_CodeEditor.default, {
    defaultValue: content,
    onChange: function onChange(html) {
      return onContentChange(html);
    },
    onBlur: onBlur,
    setCodeMirrorRef: setCodeMirrorRef,
    options: {
      lineNumbers: true,
      mode: 'text/html',
      // @ts-expect-error
      selectionPointer: true,
      autoRefresh: true,
      autoResize: true
    }
  }))));
};

exports.RawEmailEditor = RawEmailEditor;
var _default = RawEmailEditor;
exports.default = _default;